import React, { Component } from 'react';
import ReportHeader from '../../ReportHeader'
import ReportHeader2 from '../../ReportHeader2'
import Section from '../../ReportSection/index'
import T from 'i18n-react'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import SuccessStatus from '../../SuccessStatus/index'
import { connect } from 'react-redux'
import { downloadFiles } from 'containers/Project/NvqualSection/actions'
import { compose } from 'recompose';

const mapDispatchToProps = (dispatch) => {
  return {
      onDownloadFile: (files, name) => dispatch(downloadFiles(files, name))
  }
}

class PexPeerToPeerTest extends Component {
    render(){
        const { onDownloadFile, files, testName, testId, result } = this.props

        return(
        <Section>
            <ReportHeader title={T.translate(`containers.project.nvqualSection.test.${testId}`)}
                  showDownload
                  onDownloadClick={onDownloadFile.bind(this, files.map((f) => f.id), testName)}/>
            <Section>
                <ReportHeader2 title={'Summary'} />
                <Section>
                <SuccessStatus result={result} />
                </Section>
            </Section>
        </Section>
        );
    }
    }

    const withConnect = connect(null, mapDispatchToProps)
    const withStyles = CSSModules(styles);
    const enhance = compose(withConnect, withStyles);
    export default enhance(PexPeerToPeerTest);